var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRightArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  className: "rightArrow_svg__icon",
  viewBox: "0 0 1024 1024"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#CDCDCD",
  d: "M749.739 512v4.352A39.85 39.85 0 0 1 736.597 544L312.661 925.867a40.021 40.021 0 0 1-53.504-59.478l393.899-354.73-393.899-354.646a40.021 40.021 0 0 1 53.504-59.477l424.022 381.781A39.94 39.94 0 0 1 749.739 512"
})));
export default SvgRightArrow;